module.exports = "    <h1>Willkommen</h1>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.html
// module id = 1130
// module chunks = 1